import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageSearch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageSearch"><Path d="M20.5 17.5C20.5 18.62 20.0397 19.6325 19.2979 20.3587C18.5766 21.0647 17.5891 21.5 16.5 21.5C14.2909 21.5 12.5 19.7091 12.5 17.5C12.5 15.2909 14.2909 13.5 16.5 13.5C18.7091 13.5 20.5 15.2909 20.5 17.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10 21.5H4.5V2.5H19.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.501 21.5002L19.2988 20.3589" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageSearch;
